import { render } from "./RadioFormaPagamento.vue?vue&type=template&id=6ebdde99&scoped=true&ts=true"
import script from "./RadioFormaPagamento.vue?vue&type=script&lang=ts"
export * from "./RadioFormaPagamento.vue?vue&type=script&lang=ts"

import "./RadioFormaPagamento.vue?vue&type=style&index=0&id=6ebdde99&scoped=true&lang=css"

import exportComponent from "D:\\UniParking\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebdde99"]])

export default __exports__